import Api from 'api';
import React, { Component } from 'react';
import { throttle, debounce } from 'lodash';
import { GoTelescope } from 'react-icons/go';
import { MdSearch as SearchIcon } from 'react-icons/md';

export default class SearchBar extends Component {

  constructor(props) {

    super(props);

    this.api = new Api();

    this.state = {
      query: '',
      results: [],
      loading: false,
    }

    this.current_keyword = '';

    this.throttle_results = throttle(this.fetch_api_data, 500);

    this.debounce_results = debounce(this.fetch_api_data, 1000);

  }

  componentDidMount = () => {

    this.popup = document.getElementById('popup');

    this.input = document.getElementById('search');

    document.addEventListener('click', this.on_select_result);

    this.input.addEventListener('focus', () => this.popup.style.display = 'block');

  }

  on_select_result = (e) => {

    const hide_popup = (e.target!==this.input) && !this.popup.contains(e.target);

    if (!!hide_popup) return this.popup.style.display = 'none';

  }

  handle_search = async (e) => {

    this.loading(true);

    const {value=''} = e.target;

    this.current_keyword = value;

    if (value.length < 5 || value.endsWith(' ')) {
      await this.throttle_results(value);
    } else {
      await this.debounce_results(value);
    }

  }

  fetch_api_data = async (keyword) => {

    const data = await this.api.search(keyword) || [];

    //console.log('search_data :', data.map(a => a.title));

    if (keyword===this.current_keyword) return this.results(keyword,data);

  }

  results = (q,d) => this.setState({query:q,results:d}, () => this.loading(false));

  loading = (value) => {
    const { query, loading } = this.state;
    const ignore = !value && (query!==this.current_keyword);
    if (!ignore && loading!==value) return this.setState({loading: value});
  }

  render() {
    return (
      <form className={`Nav-Search-Bar ${this.props.hidden}`} autoComplete='off'>

        <input
          id='search'
          type="text"
          className='Search-Input'
          onChange={this.handle_search}
          placeholder='Search Products or Select Category'
        />

        <div className="Search-Button">
          <SearchIcon/>
        </div>

        <SearchResults data={this.state.results}/>

      </form>
    )
  }
}

const SearchResults = ({ data=[] }) => {

  const handle_click = (result) => {
    const { handle, category } = result;
    window.open(`/products/${category}/${handle}`,'_self');
  }

  return (
    <div id='popup' className='search-results'>
      <Results data={data} onClick={handle_click}/>
    </div>
  );

};

const Results = ({ data, onClick }) => {

  if (data.length === 0) return (<EmptyState/>);

  return (
    <div id='results-list'>
      {
        data.map((a) =>
          <div onClick={() => onClick(a)} key={a.id} className='result'>
            <div className="image" style={image(a.image)}/>
            <div className="caption">{a.title}</div>
            <div className="placement">in {a.category}</div>
          </div>
        )
      }
    </div>
  )

}

const EmptyState = () => (
  <div className='empty_state'>
    <div className="image">
      <GoTelescope className='icon'/>
    </div>
    <div className="caption">
      Refine your search with operators like @user, #hashtag, etc, to get better results.
    </div>
  </div>
);

const image = (url) => ({ backgroundImage: `url(${url})`})
